import { z } from "zod";
import { courtLevelSchema } from "./court-level";
import { courtTypeSchema } from "./court-type";

export const caseCategorySchema = z.object({
	id: z.string().optional(),
	name: z.string(),
	code: z.string(),
	description: z.string().optional(),
	service_type: z.string(),
	court_level: z.string().optional(),
	status: z.string().optional(),
	court_type: z.string(),
	courtType: courtTypeSchema.optional(),
	courtLevel: courtLevelSchema.optional(),
	created_at: z.string().optional(),
});

export type CaseCategory = z.infer<typeof caseCategorySchema>;
